import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { useLoanDetails, useLoanInterest } from '../../fetchHooks/useLoans';
import type { AccountId } from '../../generated-types';
import getLoanInterest from '../../utils/mapper/getLoanInterest';

const useLoans = (accountId: AccountId | undefined, hasLoanDetails: boolean | undefined) => {
    const interestQuery = useLoanInterest(accountId);
    const interest = getLoanInterest(interestQuery.data);
    const { data: loanDetails, ...loanDetailsQuery } = useLoanDetails(accountId, hasLoanDetails === true);

    const isLoading = interestQuery.isLoading || loanDetailsQuery.isLoading;
    const error = interestQuery.error ?? loanDetailsQuery.error;

    const refetch = () => {
        interestQuery.invalidateQuery();
        loanDetailsQuery.invalidateQuery();
    };

    const showLoanDetails = (Boolean(interest) || Boolean(loanDetails)) && Boolean(hasLoanDetails);
    return {
        isLoading,
        interest,
        showLoanDetails,
        loanDetails,
        error: error as RequestExceptionWithResponse | undefined,
        refetch,
    };
};

export default useLoans;
